import { Routes } from '@angular/router';
import { authGuard } from './app/auth/guards/auth.guard';
import { guestGuard } from './app/auth/guards/guest.guard';
import { AppLayout } from './app/layout/app.layout';
import { AuthLayout } from './app/layout/app.authlayout';

export const appRoutes: Routes = [
    {
        path: '',
        component: AppLayout,
        canActivate: [authGuard],
        children: [
            {
                path: 'espace-tarificateur',
                loadComponent: () => import('./app/espaces/espace-tarificateur/espace-tarificateur.component').then((c) => c.EspaceTarificateurComponent),
                canActivate: [authGuard],
                data: { roles: ['ROLE_TARIFICATEUR', 'ROLE_SUPER_TARIFICATEUR'] }
            },
            {
                path: 'espace-prospect',
                loadComponent: () => import('./app/espaces/espace-prospect/espace-prospect.component').then((c) => c.EspaceProspectComponent),
                canActivate: [authGuard],
                data: { roles: ['ROLE_PROSPECT'] }
            },
            {
                path: 'espace-medecin',
                loadComponent: () => import('./app/espaces/espace-medecin/espace-medecin.component').then((c) => c.EspaceMedecinComponent),
                canActivate: [authGuard],
                data: { roles: ['ROLE_MEDECIN'] }
            },
            {
                path: 'espace-admin',
                loadComponent: () => import('./app/espaces/espace-admin/espace-admin.component').then((c) => c.EspaceAdminComponent),
                canActivate: [authGuard],
                data: { roles: ['ROLE_ADMIN'] }
            }
        ]
    },
    {
        path: '',
        component: AuthLayout,
        children: [
            {
                path: 'login',
                loadComponent: () => import('./app/auth/login/login.component').then((c) => c.LoginComponent),
                canActivate: [guestGuard]
            },
            {
                path: 'forgot-password',
                loadComponent: () => import('./app/auth/forgot-password/forgot-password.component').then((c) => c.ForgotPasswordComponent),
                canActivate: [guestGuard]
            },
            {
                path: 'new-password',
                loadComponent: () => import('./app/auth/new-password/new-password.component').then((c) => c.NewPasswordComponent),
                canActivate: [guestGuard]
            }
        ]
    },
    { path: '**', redirectTo: '/login' }
];
